import axios from 'axios';
//import { stopSubmit } from 'redux-form';
import React, { Component} from 'react';
import { stopSubmit } from 'redux-form';
import { connect } from 'react-redux';
import { setLoading } from './loader';
import {
    USERALL_LOAD,
    USERALL_LOADING,
    USERALL_ERROR,

    USER_LOADING,
    USER_LOADED,
    AUTH_ERROR,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGIN_LOADING,
    LOGOUT_SUCCESS,
    USER_LOADED_ALL,

    USERSELECT_LOAD,
    USERSELECT_LOADING,
    USERSELECT_ERROR,

    USER_EDIT_LOADING,
    USER_EDIT_LOADED,
    USER_EDIT_ERROR,

    USERS_TIPO_LOADED,
    USERS_TIPO_LOADING,
    USERS_TIPO_ERROR,

    USER_NATURALISTA_LOADED,
    USER_NATURALISTA_COUNT_LOADED,
    USER_NATURALISTA_ERROR,
    USER_NATURALISTA_LOADING,
    
    USERS_DATA_LOADING,
    USERS_DATA_LOADED,
    USERS_DATA_ERROR,

    REGISTER_USER_LOADING,
    REGISTER_USER_LOADED,
    REGISTER_USER_ERROR
  } from './../types/usertypes';
  export const UserRegister = (data) => async (dispatch, getState) => {
    dispatch({ 
        type: REGISTER_USER_LOADING 
    });
    try {
        const res = await axios.post(`/api/auth/register`, data);
        dispatch({
            type: REGISTER_USER_LOADED,
            payload: res.data
        });
    } catch (error) {
        dispatch ({
            type: REGISTER_USER_ERROR,
            payload : error.response.data
        })
    }
  };  
  export const getUserNaturalista = (is_list = false) => async (dispatch, getState) => {
    dispatch({ 
        type: USER_NATURALISTA_LOADING 
    });
    try {
        const res = await axios.get(`/api/usernaturalista/?is_list=${is_list}`);
        dispatch({
            type: is_list ? USER_NATURALISTA_LOADED : USER_NATURALISTA_COUNT_LOADED,
            payload: res.data
        });
    } catch (error) {
        dispatch ({
            type: USER_NATURALISTA_ERROR,
            payload : error.message
        })
    }
  };
  export const login = ({ username, password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    dispatch({ 
      type: LOGIN_LOADING 
    });
    const body = JSON.stringify({ username, password });

    try {
        const res = await axios.post('/api/auth/login', body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response.data
        });
    }
};
export const getUser = (username) => async (dispatch, getState) => {
  dispatch({ 
      type: USERS_DATA_LOADING 
  });
  try {
    const res = await axios.get(`/api/users/${username}`);
    dispatch({
      type: USERS_DATA_LOADED,
      payload: res.data
    });
  } catch (error) {
    dispatch({
      type: USERS_DATA_ERROR,
      payload : error.message
    });
  }
};
export const getTipoUsers = (page,tipo = '') => async (dispatch, getState) => {
  dispatch({ 
      type: USERS_TIPO_LOADING 
  });
  try {
    const params = {
        page,
        ...(tipo && { tipo })
      };
    const res = await axios.get('/api/users', {params});
    dispatch({
      type: USERS_TIPO_LOADED,
      payload: res.data
    });
  } catch (error) {
    dispatch({
      type: USERS_TIPO_ERROR,
      payload : error.message
    });
  }
};

export const loadUserAll = () => async (dispatch, getState) => {
  dispatch({ 
      type: USERALL_LOADING 
  });
  try {
    const res = await axios.get('/api/userall', tokenConfig(getState));
    dispatch({
      type: USERALL_LOAD,
      payload: res.data
    });
  } catch (error) {
    dispatch({
      type: USERALL_ERROR,
      payload : error.message
    });
  }
};

export const loadUserSelect = () => async (dispatch, getState) => {
  dispatch({ 
      type: USERSELECT_LOADING 
  });
  try {
    const res = await axios.get('/api/userselect', tokenConfig(getState));
    dispatch({
      type: USERSELECT_LOAD,
      payload: res.data
    });
  } catch (error) {
    dispatch({
      type: USERSELECT_ERROR,
      payload : error.message
    });
  }
};

export const loadUser = () => async (dispatch, getState) => {
    dispatch({ 
        type: USER_LOADING 
    });
    try {
      const res = await axios.get('/api/auth/user', tokenConfig(getState));
      dispatch({
        type: USER_LOADED,
        payload: res.data
      });
      return res.data;
    } catch (error) {
      dispatch({
        type: AUTH_ERROR,
        payload : error.message
      });
      throw error;
    }
};

// LOGOUT USER
export const logout = () => async (dispatch, getState) => {
  await axios.post('/api/auth/logout', null, tokenConfig(getState));
  dispatch({
    type: LOGOUT_SUCCESS
  });
};


// EDIT USER
export const editUser = formValues => async (dispatch, getState) => {
  dispatch({ 
      type: USER_EDIT_LOADING 
  });

  try {
    dispatch(setLoading(true));
    const formData = new FormData();

    const isImageUrl = (value) => {
      // Verificar si el valor es una URL de imagen
      return (typeof value === 'string' && (value.startsWith('http://') || value.startsWith('https://')) && /\.(jpg|jpeg|png|gif)$/i.test(value));
    };

    for (const key in formValues) {
      if (formValues.hasOwnProperty(key)) {
        const value = formValues[key];

        if (Array.isArray(value)) {
          // Verificar si es un array de archivos (File)
          if (value.every(item => item instanceof File)) {
            value.forEach((file, index) => {
              formData.append(`${key}[${index}]`, file);
            });
          } else {
            console.log(`Omitting array field ${key} because it contains non-File items`);
          }
        } else if (value instanceof File) {
          // Si es un archivo (File), agregarlo a FormData
          formData.append(key, value);
        } else if (isImageUrl(value)) {
          // Omitir si es una URL de imagen
          console.log(`Omitting field ${key} because it is an image URL`);
        } else {
          // Agregar otros tipos de datos (como texto, enlaces a redes sociales, etc.)
          formData.append(key, value);
        }
      }
    }
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...tokenConfig(getState).headers
      }
    };

    const res = await axios.put(
      `/api/auth/edit/useredit/${formValues['id']}/`,
      formData ,
      config  
    );
    dispatch({
      type: USER_EDIT_LOADED,
      payload: res.data
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: USER_EDIT_ERROR,
      payload : error.message
    });
    throw error;
  } finally {
    dispatch(setLoading(false)); // Desactivar loader al finalizar la operación
  }
};

export const tokenConfig = getState => {

  const token = getState().user.token;

  const config = {
      headers: {
          'Content-Type': 'application/json',
      }
  };

  if (token) {
    config.headers['Authorization'] = `Token ${token}`;
  }

  return config;
};